import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { errorText } from './holidayWorldContacts';

const FIELDS = [['first_name', 'Nome', 'text'], ['last_name', 'Cognome', 'text'], ['email', 'Email', 'email']];

export const HolidayWorldAssigneeForm = ({ initial, onSave, onCancel, testid }) => {
  const [form, setForm] = useState({ first_name: initial?.first_name || '', last_name: initial?.last_name || '', email: initial?.email || '', active: initial?.active ?? true });
  const [busy, setBusy] = useState(false), [error, setError] = useState('');
  async function submit(e) {
    e.preventDefault(); e.stopPropagation(); setBusy(true); setError('');
    try { await onSave(form); } catch (err) { setError(errorText(err)); } finally { setBusy(false); }
  }
  return <form onSubmit={submit} className="space-y-3 rounded-md border border-slate-200 bg-slate-50 p-4" data-testid={testid}>
    <div className="grid gap-3 sm:grid-cols-3">{FIELDS.map(([key, label, type]) => <div key={key} className="min-w-0 space-y-1">
      <Label htmlFor={`${testid}-${key}`}>{label}</Label>
      <Input id={`${testid}-${key}`} type={type} required maxLength={key === 'email' ? 254 : 80} value={form[key]} disabled={busy}
        onChange={e => setForm(current => ({ ...current, [key]: e.target.value }))} data-testid={`${testid}-${key.replace('_', '-')}`} />
    </div>)}</div>
    {error && <p role="alert" className="text-sm text-red-700" data-testid={`${testid}-error`}>{error}</p>}
    <div className="flex justify-end gap-2">
      <Button type="button" variant="outline" disabled={busy} onClick={onCancel} data-testid={`${testid}-cancel`}>Annulla</Button>
      <Button type="submit" disabled={busy} data-testid={`${testid}-save`}>{busy ? 'Salvataggio…' : 'Salva persona'}</Button>
    </div>
  </form>;
};
